import type { FaireProductEntity } from "../../entity_types/product";

export const p_d2ae2uqvrr: FaireProductEntity = {
  token: "p_d2ae2uqvrr",
  type: "product",
  name: "Daisies Drying Mat",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/1581867519b2be2e322d46d01cbb4cc429a1c4305471791b64c73b6ccf4c2acc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c8b4ab922d1bbccbbd4a72af3202fa94067b00b1b59c7f07e71009eb31ca7cc.jpeg",
    "https://cdn.faire.com/fastly/b3283181f4df8368bb5babf4bc1fa58ca28e304f1a007f85492717e7e7b29737.jpeg",
    "https://cdn.faire.com/fastly/29e5c3e296d7cdfc7f0e4ec73d0f44a8e884bc1bc6e8d07dd1a2ef5399a6c6b2.jpeg",
    "https://cdn.faire.com/fastly/ba9b0be06cdb429883b25002afd2cdd735d8170101aafc6a8ae3bfb2035019ff.jpeg"
  ],
  priceDollars: 5,
  description: "An ultra-absorbent drying mat from our Garden Collection displaying a charming pattern of daisies replicated from original art hand painted in a delicate watercolor style. This daisy drying mat features a full color design on the 21 inch by 14 inch space to place items for drying with a coordinating green color on the back and trim. Our Daisies drying mat includes a hanger at the top to display the design or to air dry when not in use. Kitchen drying mat is conveniently machine-washable for easy cleaning and folds up for easy storage. A stylish garden-themed kitchen accessory perfect for everyday use.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:21.123Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
